import { useFormikContext } from 'formik';
import React from 'react';
import { InputLabel, Poppins, Spacer } from 'src/common';
import Input from 'src/components/form/Input';
import { BusinessTypeSelect, OrganisationTypeSelect } from 'src/components/select';
import { Profile, UpsertOrganisationMutationVariables } from 'src/graphql/_generated';
import { useAuth } from 'src/state/auth';
import styled from 'styled-components';

const Div = styled.div`
  .workspace-create-question {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    &__option {
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }
`;

interface Step2Props {
  selectedSettingsOption?: Profile['orgSettingsOptions'][number];
  createWorkspace: boolean;
  onCreateWorkspaceChange: (value: boolean) => void;
}

export const Step2: React.FC<Step2Props> = ({ selectedSettingsOption, createWorkspace, onCreateWorkspaceChange }) => {
  const { values, errors, touched, setFieldValue, setFieldTouched } =
    useFormikContext<UpsertOrganisationMutationVariables>();
  const { profile } = useAuth();

  const availableOrganisationTypes = profile?.orgSettingsOptions
    .map((el) => el.organisationType)
    .filter((el) => el !== null && el !== undefined);

  return (
    <Div>
      <InputLabel>ORGANISATION TYPE</InputLabel>
      <OrganisationTypeSelect
        restrictedTo={availableOrganisationTypes}
        onChange={(o) => {
          setFieldValue('organisationType', o.value);
          setFieldValue('businessType', null);
        }}
        onBlur={() => setFieldTouched('organisationType', true)}
        value={values.organisationType}
        css="width: 100%;"
        error={touched.organisationType && Boolean(errors.organisationType)}
      />
      <Spacer $px={20} />

      {selectedSettingsOption?.businessType && (
        <>
          <InputLabel>BUSINESS TYPE</InputLabel>
          <BusinessTypeSelect
            restrictedTo={selectedSettingsOption?.businessType}
            onChange={(o) => setFieldValue('businessType', o.value)}
            onBlur={() => setFieldTouched('businessType', true)}
            value={values.businessType}
            css="width: 100%;"
            error={touched.businessType && Boolean(errors.businessType)}
          />
          <Spacer $px={20} />
        </>
      )}

      <Spacer $px={20} />
      <div className="workspace-create-question">
        <Poppins px={14} color="cflowerBlue">
          Would you like to create a workspace
          <br /> within this organisation?
        </Poppins>
        <div className="workspace-create-question__option">
          <Poppins px={14} weight={500} color="cflowerBlue">
            No
          </Poppins>
          <Input
            data-cy="org-workspace-switch"
            checked={createWorkspace}
            onChange={(e) => onCreateWorkspaceChange(e.target.checked)}
            className="switch"
            type="checkbox"
          />
          <Poppins px={14} weight={500} color="cflowerBlue">
            Yes
          </Poppins>
        </div>
      </div>
    </Div>
  );
};
